<template>
    <div class="general">
        <div class="general-width">
            <GeneralHeader type="Mission" :title="mission.name || 'loading...'"
                :can_edit="user_perms.some(e => e.name == 'edit_mission') || fullAccess"
                :can_delete="user_perms.some(e => e.name == 'delete_mission') || fullAccess"
                @editModal="dialogEditMission = true" @deleteModal="dialogDeleteMission = true" />
            <v-skeleton-loader v-if="loading" type="card"></v-skeleton-loader>
            <MissionInfo v-if="!loading" :mission="mission" :user_perms="user_perms" :full_access="fullAccess" />
        </div>
    </div>

    <v-overlay v-model="dialogDeleteMission" location="top" style="justify-content:center;align-items: center;">
        <ConfirmForm :text="'Are you sure you wanna delete mission ' + mission.name + ' ?'" :typeToDelete="mission.name"
            @close="dialogDeleteMission = false" @confirm="deleteMission()"></ConfirmForm>
    </v-overlay>

    <v-overlay v-model="dialogEditMission" location="top" style="justify-content:center;align-items: center;">
        <EditMissionForm :mission="mission" @close="dialogEditMission = false"></EditMissionForm>
    </v-overlay>
</template>

<script setup>
import ConfirmForm from '@/components/admin/forms/ConfirmForm.vue';
import EditMissionForm from '@/components/admin/forms/EditMissionForm.vue';
import GeneralHeader from '@/components/admin/layouts/GeneralHeaderCard'
import MissionInfo from '@/components/admin/missions/MissionInfo'
import router, { checkFullAccessPermissionOnMission } from '@/router';
import { useMissionStore } from '@/store/missionStore';
import { storeToRefs } from 'pinia';
import { onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';

const props = defineProps({
    user_perms: Object,
    is_user_logged: Boolean
});


const loading = ref(true);
const missionStore = useMissionStore();
const { mission } = storeToRefs(missionStore);
const route = useRoute();

const dialogEditMission = ref(false);
const dialogDeleteMission = ref(false);

const fullAccess = ref(false);

onMounted(() => {

    missionStore.fetchMission(route.params.id).then(() => loading.value = false);
    fullAccess.value = checkFullAccessPermissionOnMission(route.params.id)

})


const deleteMission = async () => {
    loading.value = true;
    await missionStore.deleteMission(mission.value.id);
    dialogDeleteMission.value = false;
    loading.value = false;
    router.push("/");
}


</script>